// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  urlApi: 'https://old.unimedodonto.com.br/api/',
  urlApiAdmin: 'https://old.unimedodonto.com.br/admin/api/',
  urlDocumentos: 'https://old.unimedodonto.com.br/odonto/api/',
  urlDocuware: 'https://unimedodonto.greend.com.br/UnimedWebAPI/api/Unimed/GetImage?ID=',
  urlInstitucional: 'https://www.unimedodonto.com.br/',
  urlIp: 'https://api.digital-segurosunimed.com/retrive-user-ip',
  urlLog: 'https://old.unimedodonto.com.br/odonto/api/log',
  urlLogin: 'https://old.unimedodonto.com.br/session/',
  urlLoginAdmin: 'https://old.unimedodonto.com.br/admin/session/',
  urlMain: 'https://old.unimedodonto.com.br/prestador/',
  urlMaterialApoio: 'https://old.unimedodonto.com.br/prestador/material-apoio',
  urlToken: 'https://api.digital-segurosunimed.com/tokencorporativo/v1/token',

  firebase: 'https://prd-seguros-unimed-geral.firebaseio.com/aplicacoes/odonto/prestador',

  tokenXApiKey : 'T1q4v4jqHH9uuHT8hO8h7367eg3oqHh43VQXGDn6',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts